import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const PrivacyPolicy = lazy(() => import('../pages/privacy/page'));
const LegalDisclaimer = lazy(() => import('../pages/disclaimer/page'));
const TermsOfUse = lazy(() => import('../pages/terms/page'));
const OurServices = lazy(() => import('../pages/our-services/page'));
const MediaInsights = lazy(() => import('../pages/media-insights/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/home" replace />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/legal-disclaimer',
    element: <LegalDisclaimer />,
  },
  {
    path: '/terms-of-use',
    element: <TermsOfUse />,
  },
  {
    path: '/our-services',
    element: <OurServices />,
  },
  {
    path: '/media-insights',
    element: <MediaInsights />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;